import React from 'react';
import { Globe, Mail, ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-green-800 text-white">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* CROCUS Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://i.ibb.co/rRJ3gJzs/crocus-dark.png" 
                alt="CROCUS Logo" 
                className="h-12 mr-4"
              />
            </div>
            <p className="text-gray-300 text-sm">
            CROCUS is a science initiative researching how extreme weather 
            conditions impact the Chicago region and its people.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://crocus-urban.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white flex items-center"
                >
                  <Globe size={16} className="mr-2" />
                  CROCUS Website
                </a>
              </li>
              <li>
                <a 
                  href="https://berkelha.github.io/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white flex items-center"
                >
                  <ExternalLink size={16} className="mr-2" />
                  ACE Lab @ UIC
                </a>
              </li>
              <li>
                <a 
                  href="https://gonzalez-melerisotopelab.weebly.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white flex items-center"
                >
                  <ExternalLink size={16} className="mr-2" />
                  Stable Isotope Lab @ UIC
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2">
              <a 
                href="mailto:berkelha@uic.edu"
                className="text-gray-300 hover:text-white flex items-center"
              >
                <Mail size={16} className="mr-2" />
                berkelha@uic.edu
              </a>
              <p className="text-gray-300 text-sm mt-4">
                Have questions about the data or interested in collaboration? 
                We'd love to hear from you.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-4 border-t border-green-700">
          <div className="flex justify-center">
            <p className="text-gray-300 text-sm">
              © {currentYear} CROCUS. All rights reserved.
            </p>
          </div>
        </div>

        {/* Funding Attribution */}
        <div className="mt-4 text-center text-xs text-gray-400">
          This project is funded by the U.S. Department of Energy's Office of Science.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
